var map = {
	"./amanha.jpg": 5260,
	"./closeup.jpg": 3949,
	"./design&philosophySociety.jpg": 5617,
	"./economiadeartista.jpg": 214,
	"./paintsucks.jpg": 7285,
	"./scopio.jpg": 6075
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1846;